import React from 'react';

import _ from 'lodash';

import { FormRow, SelectInput, TextInput } from '../reactHookForm';
import Prefixes from 'src/models/Prefixes';
import Suffixes from 'src/models/Suffixes';

const maritalStatus = [
    { id: 1, name: 'a married man' },
    { id: 2, name: 'a married woman' },
    { id: 3, name: 'a married person' },
    { id: 4, name: 'a single man' },
    { id: 5, name: 'a single woman' },
    { id: 6, name: 'a single person' },
    { id: 7, name: 'a widower' },
    { id: 8, name: 'a widow' },
    { id: 9, name: 'husband and wife' },
    { id: 10, name: 'wife and husband' },
    { id: 11, name: 'husband and husband' },
    { id: 12, name: 'wife and wife' },
];

interface IPersonDataProps {
    labelPrefix?: string;
    namePrefix?: string;
    includeFields?: Array<'AKA' | 'MaritalStatus'>;
    required?: boolean;
}

const PersonData: React.FC<IPersonDataProps> = (props) => {
    // TODO: check if in formprovider context

    const name = (n: string) => {
        if (props.namePrefix) {
            if (props.namePrefix.endsWith('.')) {
                return `${props.namePrefix}${n}`;
            } else {
                return `${props.namePrefix}${n.charAt(0).toUpperCase() + n.slice(1)}`;
            }
        }
        return n;
    };

    const label = (l: string) => {
        if (props.labelPrefix) {
            return `${props.labelPrefix} ${l}`;
        }
        return l;
    };

    return (
        <>
            <FormRow layout={[2, 3, 3, 3, 2]}>
                <SelectInput label={label(`Prefix`)} name={name('prefix')} isCreatable={true} options={Prefixes} />
                <TextInput isRequired={props.required} label={label('First Name')} name={name('firstName')} />
                <TextInput label={label('Middle Name')} name={name('middleName')} />
                <TextInput isRequired={props.required} label={label('Last Name')} name={name('lastName')} />
                <SelectInput label={label('Suffix')} name={name('suffix')} isCreatable={true} options={Suffixes} />
            </FormRow>
            {props.includeFields && (
                <>
                    {_.includes(props.includeFields, 'AKA') && _.includes(props.includeFields, 'MaritalStatus') && (
                        <FormRow layout={[5, 5, 3]}>
                            <TextInput label={label('Also Known As')} name={name('aka')} />
                            <SelectInput isCreatable={true} label={label('Marital Status')} name={name('maritalStatusId')} options={maritalStatus} />
                            <TextInput label={label('SSN')} name={name('ssnTaxId')} />
                        </FormRow>
                    )}
                    {props.includeFields.length === 1 && _.includes(props.includeFields, 'AKA') && (
                        <FormRow layout={[5, '8_']}>
                            <TextInput label={label('Also Known As')} name={name('aka')} />
                        </FormRow>
                    )}
                </>
            )}
            <FormRow layout={[5, '8_']}>
                <TextInput label={label('Email')} name={name('email')} />
            </FormRow>
        </>
    );
};

PersonData.defaultProps = {
    required: false,
};

export default PersonData;



// WEBPACK FOOTER //
// ./src/components/controls/forms/composite/PersonData.tsx